import excessStockIcon from '../assets/image/excess-stocks-icon.svg';
import lowStockIcon from '../assets/image/low-stock-icon.svg';
import nearExpiryIcon from '../assets/image/near-expiry-batch-icon.svg';
import expiredIcon from '../assets/image/expired-batch-icon.svg';

export const constant = {
	bigNumber: 1e5,
	drugLicenseRegex: /^([^\d]*\d){12}[^\d]*$/,
	panCardRegex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
	emailRegex: /\S+@\S+\.\S+/,
	gstRegex: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
};

export const CREDIT_NOTE_TYPE = {
	1: 'Damaged/Returned Goods',
	2: 'Excess Payment',
	3: 'Advance Payment',
};

export const productStatusList = [
	'Inactive Products',
	'Low Stocks Products',
	'Out Of Stocks',
	'Excess Stocks',
	'Near Expiry Stocks',
	'Expired Stocks',
	'Sales',
	'Purchase',
];

export const checkProductStatus = (tag) => {
	switch (tag) {
		case 'Low Stocks Products':
			return 'low_stock';
		case 'Out Of Stocks':
			return 'out_of_stock';
		case 'Expired Stocks':
			return 'expired';
		case 'Near Expiry Stocks':
			return 'near_expiry';
		case 'Excess Stocks':
			return 'excess_stock';
		case 'Inactive Products':
			return 'inactive';
		case 'Sales':
			return 'sales_product';
		case 'Purchase':
			return 'purchase_product';
		default:
			return tag;
	}
};
export const formatTag = (tag) => {
	switch (tag) {
		case 'low_stock':
			return 'Low Stock';
		case 'out_of_stock':
			return 'Product Out of Stock';
		case 'expired':
			return 'Batch Expired';
		case 'near_expiry':
			return 'Batch Near Expiring';
		case 'excess_stock':
			return 'Excess Stock';
		case 'inactive':
			return 'Inactive';
		case 'sales_product':
			return 'Sales Product';
		case 'purchase_product':
			return 'Purchase Product';
		default:
			return tag;
	}
};
export const colorFormatTag = (tag) => {
	switch (tag) {
		case 'low_stock':
			return '#E7E3B4';
		case 'out_of_stock':
			return '#FFEED5';
		case 'expired':
			return '#FCCFCF';
		case 'near_expiry':
			return '#FFEDED';
		case 'excess_stock':
			return '#BEE8E2';
		case 'sales_product':
			return '#B3E0FF';
		case 'purchase_product':
			return '#F9E8FC';
		default:
			return '#718096';
	}
};
export const batchColorFormatTag = (tag) => {
	switch (tag) {
		case 'low_stock':
			return '#FEC53D';
		case 'out_of_stock':
			return '#FF0000';
		case 'expired':
			return '#A0616A';
		case 'near_expiry':
			return '#EB996E';
		case 'excess_stock':
			return '#16EACC';
		default:
			return '#718096';
	}
};
export const iconFormatTag = (tag) => {
	switch (tag) {
		case 'low_stock':
			return lowStockIcon;
		case 'expired':
			return expiredIcon;
		case 'near_expiry':
			return nearExpiryIcon;
		case 'excess_stock':
			return excessStockIcon;
		default:
			return null;
	}
};

export function generateArray(limit) {
	return Array.from({ length: limit }, (_, i) => ({
		key: i,
		value: i,
	}));
}
export const isNumber = (id) => {
	return typeof id === 'number' && !Number.isNaN(id);
};
